import { Component, OnInit, NgZone } from '@angular/core';
import * as KJUR from 'jsrsasign';
import { NgForm } from '@angular/forms';
import { NotifierService } from '../../system/shared/notifier/notifier.service';
import { UserService } from '../../system/services/usuario.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.scss'],
  providers: [UserService]
})
export class NewPasswordComponent implements OnInit {
  recoveryData: any = {};
  token;
  constructor(private zone: NgZone, private notifierService: NotifierService, private userService: UserService, private route: ActivatedRoute, private _route: Router) { }

  ngOnInit() {
    this.zone.run(() => {
      this.route.params.subscribe((params) => {
        this.token = params['token'];
      })
      console.log(this.route.snapshot.queryParams);
    });
  }

  sendNewPassword(form: NgForm) {
    if (form.valid) {

      const oHeader = { alg: 'HS256', typ: 'JWT' };
      // Payload
      const oPayload: any = {};
      oPayload.claveNueva = this.recoveryData.claveNueva;
      const sHeader = JSON.stringify(oHeader);
      const sPayload = JSON.stringify(oPayload);

      const sJWT = KJUR.jws.JWS.sign('HS256', sHeader, sPayload, 'Vbxq2mlbGJw8XH+ZoYBnUHmHga8/o/IduvU/Tht70iE=');
      this.userService.sendNewPassword(sJWT, this.token).subscribe(() => {
        this.notifierService.systemNotify({
          title: 'Exito',
          message: 'Su contraseña ha sido cambiada por favor ingrese al sistema con su nueva clave',
          type: 'success'
        });
        this._route.navigate(['public']);
      }, (error) => {
        this.notifierService.systemNotify({
          title: 'Error',
          message: error.message,
          type: 'error'
        });
      });
    }
    else {
      this.notifierService.systemNotify({
        title: 'Atención',
        message: 'Por favor valide que el campo esté llenado correctamente antes de continuar',
        type: 'warning'
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/public/new-password/new-password.component.ts